import { render, staticRenderFns } from "./bookedPickups.vue?vue&type=template&id=bc058610"
import script from "./bookedPickups.vue?vue&type=script&lang=js"
export * from "./bookedPickups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports